module.exports = __webpack_public_path__ + "static/img/phone.97c83a90.svg";